var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":function($event){return _vm.up(!_vm.flag)}}},[(_vm.flag)?[_vm._v("–")]:[_vm._v("+")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }